
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Cu3Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f4aed387faa52350$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $36IHg = parcelRequire("36IHg");

var $aACZr = parcelRequire("aACZr");

var $bsRud = parcelRequire("bsRud");

var $jFdmN = parcelRequire("jFdmN");

var $dtKoB = parcelRequire("dtKoB");

var $5aE2v = parcelRequire("5aE2v");

var $hW7sX = parcelRequire("hW7sX");

var $7xuAh = parcelRequire("7xuAh");
function $f4aed387faa52350$export$2e2bcd8739ae039() {
    const [searchParams] = (0, $36IHg.useSearchParams)();
    const unsubscribed = searchParams.get("unsubscribed") === "true";
    (0, $aACZr.default)(unsubscribed ? (0, $dtKoB.default)("Unsubscribed") : (0, $dtKoB.default)("Confirm"));
    const redirect = (0, $7xuAh.default)();
    const { confirm: confirm, openModal: openModal } = (0, $5aE2v.useModal)();
    const [error, setError] = (0, $acw62.useState)();
    const { confirmation: confirmation, isLoading: isLoading } = (0, $hW7sX.useApiData)("up.emailNotifications.confirmation.show", {
        actionId: searchParams.get("actionId") || "",
        publicKey: searchParams.get("publicKey") || "",
        secretKey: searchParams.get("secretKey") || ""
    }, {
        enable: !unsubscribed,
        onError: ({ error: error })=>{
            setError(error);
        }
    });
    const { call: callConfirm } = (0, $hW7sX.useApi)("up.emailNotifications.actions.do", {
        publicKey: searchParams.get("publicKey") || "",
        secretKey: searchParams.get("secretKey") || ""
    });
    (0, $acw62.useEffect)(()=>{
        if (!unsubscribed) return;
        confirm({
            afterClose: ()=>{
                redirect([
                    "up.root",
                    {}
                ]);
            },
            confirmText: (0, $dtKoB.default)("Return home"),
            content: (0, $dtKoB.default)("You will no longer receive email reminders about this."),
            title: (0, $dtKoB.default)("Unsubscribed")
        });
    }, [
        unsubscribed,
        confirm,
        redirect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!error) return;
        switch(error){
            case "invalid_authentication":
                confirm({
                    afterClose: ()=>{
                        redirect([
                            "up.root",
                            {}
                        ]);
                    },
                    confirmText: (0, $dtKoB.default)("Return home"),
                    content: (0, $dtKoB.default)("The link you clicked on is associated with a different account. Please log out and try again."),
                    title: (0, $dtKoB.default)("Make sure this is your link")
                });
                return;
            case "notification_confirmation_not_required":
            case "notification_expired":
            case "notification_not_found":
                confirm({
                    afterClose: ()=>{
                        redirect([
                            "up.root",
                            {}
                        ]);
                    },
                    confirmText: (0, $dtKoB.default)("Return home"),
                    content: (0, $dtKoB.default)("The link you clicked on is wrong or expired"),
                    title: (0, $dtKoB.default)("Invalid link")
                });
                return;
        }
        const exhaustCheck = error;
    }, [
        error,
        redirect,
        confirm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!confirmation) return;
        openModal({
            cancelText: confirmation.alternative?.text,
            confirmText: confirmation.confirmText,
            content: confirmation.message,
            onClick: async (confirm)=>{
                if (confirm || confirmation.alternative) {
                    const response = await callConfirm({
                        actionId: confirm ? searchParams.get("actionId") : confirmation.alternative.onClick
                    });
                    if (response.success) {
                        redirect(response.redirectUrl === false ? [
                            "up.root",
                            {}
                        ] : response.redirectUrl);
                        return;
                    }
                }
                redirect([
                    "up.root",
                    {}
                ]);
            },
            title: (0, $dtKoB.default)("Confirm"),
            type: confirmation.danger ? "warning" : undefined
        });
    }, [
        confirmation,
        redirect,
        openModal,
        callConfirm,
        searchParams
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bsRud.default), {
        children: isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFdmN.default), {})
    });
}

});
parcelRegister("aACZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b5b82c49fa2535e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $7b5b82c49fa2535e$var$DEFAULT_USE_TITLE_OPTIONS = {
    restoreOnUnmount: false
};
function $7b5b82c49fa2535e$var$useTitle(title, options) {
    if (options === void 0) options = $7b5b82c49fa2535e$var$DEFAULT_USE_TITLE_OPTIONS;
    var prevTitleRef = (0, $acw62.useRef)(document.title);
    if (document.title !== title) document.title = title;
    (0, $acw62.useEffect)(function() {
        if (options && options.restoreOnUnmount) return function() {
            document.title = prevTitleRef.current;
        };
        else return;
    }, []);
}
var $7b5b82c49fa2535e$export$2e2bcd8739ae039 = typeof document !== 'undefined' ? $7b5b82c49fa2535e$var$useTitle : function(_title) {};

});



//# sourceMappingURL=NotificationConfirmation.745b58d3.js.map
